<template>
  <div id="stickers" v-if="$store.state.isPromo">
    <div
      v-for="item in d11List"
      :key="item.title"
      tag="div"
      :to="item.url"
      class="button"
      :class="{ promo__sticker: item.isD11 }"
      @click="trigger(item)"
    >
      <i class="icon" :class="item.icon" />
      <div class="title">{{ item.title }}</div>
      <div class="subtitle">{{ item.subtitle }}</div>
    </div>
  </div>
  <div id="stickers" v-else>
    <div
      v-for="item in list"
      :key="item.title"
      tag="div"
      :to="item.url"
      class="button"
      :class="{ promo__sticker: item.isD11 }"
      @click="trigger(item)"
    >
      <i class="icon" :class="item.icon" :style="'color:' + item.color" />
      <div class="title">{{ item.title }}</div>
      <div class="subtitle">{{ item.subtitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stickers",
  data() {
    return {
      list: [
        {
          title: "关注公众号",
          subtitle: "及时领取现金",
          icon: "anyteachicon anyteach-qrcode",
          url: null,
          emit: "follow",
          isD11: false,
          color: "#ED254E",
        },
        {
          title: "课表全新上线",
          subtitle: "让学习更简单",
          icon: "animated repeated anyteachicon anyteach-calendar",
          url: "/schedule?source=front_page2",
          emit: null,
          isD11: false,
          color: "#ED254E",
        },
        // {
        //   title: "王冰暗示法英语",
        //   subtitle: "现已开放限量试听",
        //   icon: "animated repeated anyteachicon anyteach-mianfeishiting",
        //   url: "/courses/119",
        //   emit: null,
        //   isD11: false,
        //   color: "#ED254E",
        // },
      ],
      d11List: [
        {
          title: "关注公众号",
          subtitle: "及时领取现金",
          icon: "anyteachicon anyteach-qrcode",
          url: null,
          emit: "follow",
          isD11: false,
        },
        {
          title: this.$store.state.promoData.title1,
          subtitle: this.$store.state.promoData.desc2,
          icon: "anyteachicon anyteach-1212 promo-icon",
          url: "/courses?type=100",
          emit: null,
          isD11: true,
        },
      ],
    }
  },
  methods: {
    trigger(item) {
      if (item.url) {
        return this.$router.push(item.url)
      }
      if (item.emit) {
        this.$popup(item.emit)
      }
    },
  },
}
</script>

<style scoped lang="scss">
// @import "../../../static/css/public.scss";
@import "@/assets/css/promo.scss";

#stickers {
  padding: 0 0 10px 0;
  margin: 10px auto;
  overflow: auto;
  display: flex;
  justify-content: space-between;
  width: 90%;

  .button:last-of-type {
    margin: 0;
  }
  .button {
    display: inline-block;
    text-align: left;
    transition: 0.1s;
    border-radius: 3px;
    background: #f9f9f7;
    width: 100%;
    margin: 0 5px 0 0;
    padding: 10px;
    position: relative;
    &:active {
      opacity: 0.7;
    }
    .circle {
      margin: auto;
      color: $blue;
      font-size: 20px;
      border-radius: 45px;
      width: 45px;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .title {
      margin: 5px 0 3px 0;
      line-height: 1.2;
      white-space: normal;
      color: $black;
      font-size: 0.9rem;
      @include avenir-demi();
    }
    i {
      position: absolute;
      bottom: 7px;
      right: 10px;
      color: $red;
      font-size: 1.5rem;
    }
    .subtitle {
      opacity: 0.8;
      font-size: 0.8rem;
      color: $black;
      line-height: 1.3;
    }
  }
  .promo__sticker {
    background: $d11__bgd;
    color: $d11__main;
    .title,
    i {
      color: $d11__main;
    }
    border: 2px solid $d11__border;
    .subtitle {
      opacity: 1;
    }
  }
  .repeated {
    animation-duration: 1s !important;
    animation-delay: 1s !important;
    animation-iteration-count: 4 !important;
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  #shortcuts {
    margin: 10px 5%;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  #shortcuts {
    display: block;
    .button {
      margin-right: 15px;
    }
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
}
</style>
